import React from 'react';
import PropTypes from 'prop-types';

import InputText from 'primitives/InputText/InputText';

import { KEY_NAMES } from 'constants/global';
import { SearchIconSm } from '@chownow/pantry/icons';

export default function MenuSearchBar({ searchTerm, setFilterTerm, onSearch }) {
  return (
    <InputText
      size="sm"
      placeholder="Search by name or ID"
      w={260}
      leftIcon={<SearchIconSm onClick={onSearch} />}
      onChange={setFilterTerm}
      value={typeof searchTerm === 'string' ? searchTerm : null}
      onKeyDown={e => {
        if (e.key === KEY_NAMES.enter) onSearch();
      }}
    />
  );
}

MenuSearchBar.propTypes = {
  searchTerm: PropTypes.string,
  setFilterTerm: PropTypes.func,
  onSearch: PropTypes.func,
};
